import React from "react";
import { Content, Menu, Navigator } from "../../../components/Menus/Navigator";
import { Spacer, SubTitle, Theme } from "@dspworkplace/ui";
import { NavLink, Route, Switch } from "react-router-dom";
import { renderGrantedRoute, ROUTES } from "../../../Route_temp";
import { getCompanyId } from "../../../Auth";
import styled from 'styled-components'
import AccessCheck from "../../../security/AccessCheck";
import { useRecoilValue } from "recoil";
import { planDetailsState } from "../../../state/planDetail";


const VehicleContent = styled(Content)`
    width: calc(100vw - 225px);
`

const App = (routeProps) => {
    const { history, match } = routeProps;
    const { url, isExact } = match;
    const companyId = parseInt(getCompanyId());
    const { tier } = useRecoilValue(planDetailsState); 

    const routes = ROUTES.find(r => r.name === "Fleet")?.routes
        ?.find(r => r.name === "Maintenance")?.routes
        ?.filter((r) => !r.isCompany || r.isCompany.includes(companyId));

    if (isExact && routes?.length) {
        const taskTrackerRoute = routes.find(r => r.name === "TaskTracker");
        const maintenanceLogRoute = routes.find(r => r.name === "Maintenance Log");

        const hasTaskTrackerAccess =
            taskTrackerRoute &&
            AccessCheck.isGranted({
                plan: tier,
                feature: AccessCheck.addons.VEHICLE_MAINTENANCE_PLAN,
                role: null,
                ops: null,
                station: null
            });

        const defaultRoute = hasTaskTrackerAccess
            ? taskTrackerRoute
            : maintenanceLogRoute || routes[0];

        history.replace(url + defaultRoute.path);
    }

    return (
        <div style={{ display: "flex", position: "relative", height: '100%' }}>
            <Navigator style={{ width: 225 }} className="scrollable">
                <SubTitle>Maintenance</SubTitle>
                <Spacer top={3} style={{ borderBottom: "1px solid " + Theme.colors.info.bg }} />
                <Spacer top={4} />
                <Menu>
                    {routes.map((r, k) => {
                        return <React.Fragment key={`${url}${r.path}`}>
                            {r.renderMenu !== false && (
                                <li>
                                    <NavLink to={`${url}${r.path}`}>{r.name}</NavLink>
                                </li>
                            )}
                        </React.Fragment>
                    })}
                </Menu>
                <Spacer top={16} />
            </Navigator>
            <VehicleContent className="scrollable" style={{ position: "relative" }}>
                <Switch>
                    {routes.map(({ path, feature, component, avoidPermission }, k) => (
                        <Route
                            path={`${url}${path}`}
                            key={k}
                            render={(props) => {
                                if (avoidPermission && avoidPermission.includes(parseInt(getCompanyId()))) {
                                    return renderGrantedRoute({
                                        feature,
                                        component,
                                        path,
                                        avoidPermission: true
                                    })
                                } else {
                                    return renderGrantedRoute({
                                        feature,
                                        component,
                                        path
                                    })
                                }
                            }}
                        />
                    ))}
                </Switch>
            </VehicleContent>
        </div>
    );
};

export default App;